<template></template>
<script>

import Vue from 'vue'
const signalR = require('@microsoft/signalr'); 
Vue.prototype.$signalR = signalR;

export default {
    components: {},
    data() {
        return {
            signalRConnection: null,    
        }
    },
    methods: {
        async initializeSignalR() {
            await this.signalRConnection.start().catch(err => console.error(err));
            await this.signalRConnection.invoke(process.env.VUE_APP_HUB_NOTIFICATIONS_INVOKE,  this.pageQueryId);
            
            this.signalRConnection.on(process.env.VUE_APP_HUB_NOTIFICATIONS_UPDATEBADGE, data => {
                this.$emit('refresh', data)
            });
        },
    },
    created() {
        //signalR
        this.signalRConnection = new this.$signalR.HubConnectionBuilder()
                          .withUrl(`${process.env.VUE_APP_HUB_URL}notifications`) 
                          .configureLogging(this.$signalR.LogLevel.Information)
                          .withAutomaticReconnect()
                          .build();
    },
    async mounted() { 
        await this.initializeSignalR()
    },
    computed: {
        pageQueryId() {
            return `Notifications_${this.$store.state.userId}`
        }
    },
    destroyed() {
        this.signalRConnection = null
    },
}
</script>
